import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../i18n';
import './InsufficientBalanceModal.css';

interface InsufficientBalanceModalProps {
  isOpen: boolean;
  onClose: () => void;
  required: number;
  available: number;
}

export const InsufficientBalanceModal: React.FC<InsufficientBalanceModalProps> = ({
  isOpen,
  onClose,
  required,
  available
}) => {
  const navigate = useNavigate();
  const t = useTranslation();

  if (!isOpen) return null;

  const handleGoToTasks = () => {
    onClose();
    navigate('/tasks');
  };

  const handleGoToProfile = () => {
    onClose();
    navigate('/profile');
  };

  const handleGoToBalance = () => {
    onClose();
    navigate('/balance');
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{t.insufficientBalance.title}</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        
        <div className="modal-body">
          <div className="balance-info">
            <div className="balance-item">
              <span className="balance-label">{t.insufficientBalance.required}</span>
              <span className="balance-value required">💎 {required}</span>
            </div>
            <div className="balance-item">
              <span className="balance-label">{t.insufficientBalance.youHave}</span>
              <span className="balance-value available">💎 {available}</span>
            </div>
            <div className="balance-item deficit">
              <span className="balance-label">{t.insufficientBalance.missing}</span>
              <span className="balance-value">💎 {required - available}</span>
            </div>
          </div>

          <div className="earn-section">
            <h3>{t.insufficientBalance.howToEarn}</h3>
            <div className="earn-methods">
              <div className="earn-method">
                <div className="earn-icon">✅</div>
                <div className="earn-info">
                  <div className="earn-title">{t.insufficientBalance.completeTasks}</div>
                  <div className="earn-description">{t.insufficientBalance.taskReward}</div>
                </div>
              </div>
              <div className="earn-method">
                <div className="earn-icon">👥</div>
                <div className="earn-info">
                  <div className="earn-title">{t.insufficientBalance.inviteFriends}</div>
                  <div className="earn-description">{t.insufficientBalance.friendReward}</div>
                </div>
              </div>
              <div className="earn-method">
                <div className="earn-icon">🎯</div>
                <div className="earn-info">
                  <div className="earn-title">{t.insufficientBalance.practiceMeditations}</div>
                  <div className="earn-description">{t.insufficientBalance.practiceReward}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-actions">
          <button className="btn btn-primary" onClick={handleGoToBalance}>
            {t.insufficientBalance.topUpBalance}
          </button>
          <button className="btn btn-secondary" onClick={handleGoToTasks}>
            {t.insufficientBalance.goToTasks}
          </button>
          <button className="btn btn-secondary" onClick={handleGoToProfile}>
            {t.insufficientBalance.inviteFriendsBtn}
          </button>
        </div>
      </div>
    </div>
  );
};
